import React, { useState } from 'react'
import { MuiOtpInput } from 'mui-one-time-password-input'
import { TextFieldProps } from '@mui/material';
import { TranslationEnum, usePortalTranslation } from '../../../providers/TranslationProvider';
import { MAX_TIME } from '../../otpVerification/otpVerificationUtils';
import ReverseTimer from '../../../components/ReverseTimer/ReverseTimer';
import ReportToggle from './ReportToggle';
import ReportReverseTimer from './ReportReverseTimer';
// import { sendForgotPasswordOtpAddress } from '../../services/authenticationService';


const otpTextFieldsProps: TextFieldProps = {
    style: {
        background: "white",
        borderRadius: "4px",
    },
    inputProps: {
        style: {
            padding: "5px 0",
            color: "#909090",
            fontSize: "20px",
            fontWeight: 800,
        },
    },
};


interface OTPVerificationProps {
    resendOtp: () => Promise<void>;
    onSuccess: (messaage:string , response?:any) => void;
    onFailure: (message: string , response?:any) => void;
    verifyOTP: (otp:string) => Promise<{ result: boolean, message: string  , response?:any}>;
    OtpVerficationHeader?: React.ReactElement;
    loginUIConfig?:any;
    otpLength?: number;
}




function ReportOtp(props: any) {
    const CUR_COMPONENT = "ValidateOtp"
    const { translate } = usePortalTranslation();
    const { resendOtp, onSuccess, onFailure, verifyOTP,OtpVerficationHeader } = props;
    const [otp, setOtp] = useState("");
    const [resendOtpState, setresendOtpState] = useState(false);
    const [Timeleft, setTimeleft] = useState(MAX_TIME);
    const [toggleState, setToggleState] = useState(false);

    const updateOtp = (newValue: string) => {
        setOtp(newValue);
    };

    const handleResendOtp = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        await resendOtp();
        setTimeleft(MAX_TIME)
        setresendOtpState(false);
    }

    const onTimerEnd = () => {
        setresendOtpState(true);
        setTimeleft(() => 0);
    };

    function renderTimeleft() {
        if (Timeleft > 0) {
            return (
                <ReportReverseTimer
                    className="verify-OTP-Timer"
                    initialTime={Timeleft}
                    onTimerZero={onTimerEnd}
                />
            );
        } else {
            return <></>;
        }
    }


    const handleVerification = async () => {
        setToggleState(!toggleState);
        const { result, message , response} = await verifyOTP(otp);
        if (result) {
            onSuccess(message,response);
        } else {
            onFailure(message,response);
        }
        setToggleState(false);
    };


    return (
        <form className="loginInputs">
            {
                OtpVerficationHeader ? 
                    OtpVerficationHeader  : 
                    <div className="otp-label" style={{color:"#1C7EA0"}}> {translate(TranslationEnum.validate_otp,"OTP sent ")}</div>
            }
           
            <MuiOtpInput
                TextFieldsProps={otpTextFieldsProps}
                className="otp-input"
                id="otp"
                // placeholder="Enter OTP"
                value={otp}
                length={props.otpLength ?? 6}
                onChange={updateOtp}
            />
            <button
                className={resendOtpState ? "resend-otp-link" : "disableResend"}
                onClick={handleResendOtp}
                disabled={!resendOtpState}
                style={{color: "#24c6b1",marginTop:"30px"}}
            >
                {resendOtpState ? (
                    translate(TranslationEnum.validate_otp,"Resend OTP")
                ) : (
                        <span style={{ color: "black", fontWeight: 500 }}>
                            {translate(TranslationEnum.validate_otp, "Didn't receive OTP ?")}
                            <span style={{ color: "#24c6b1", fontWeight: 500  }}> Resend in </span>
                            <span style={{ color: "#24c6b1" }}>{"("}</span>
                            {renderTimeleft()}
                            <span style={{ color: "#24c6b1" }}>{")"}</span>
                        </span>
                )}
            </button>
            <ReportToggle
                status1="VERIFY"
                status2="VERIFYING"
                handleChange={handleVerification}
                updateToggleState={toggleState}
                className="login-toggle-unchecked-icon-status-translation"
            />
        </form>
    )
}

export default ReportOtp;